// ────────────────────────────
// src/index.js
// ────────────────────────────
import React       from "react";
import ReactDOM    from "react-dom/client";
import App         from "./App";
import 'animate.css/animate.min.css';
import { HelmetProvider } from "react-helmet-async";

const container = document.getElementById("root");
const root      = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <div className="app-root">
        <App />
      </div>
    </HelmetProvider>
  </React.StrictMode>
);

